export default "./dist/stdassets/images/icons/overview-map.png";